module.exports = __webpack_public_path__ + "img/6.74754df3.jpg";